var setSliderValues = function (element, data) {
    var itemCnt = $(data).length;
    var $slider = $(element);

    console.log(itemCnt);

    $slider.attr('max', itemCnt - 2);
    $slider.val(0);
}

var setSlider = function (element, container) {
    var itemWidth = 315;
    var $container = $(container);
    var $slider = $(element);
    var itemCnt = $slider.attr('max');

    $container.css('left', 0);

    $slider.on('input.slider change.slider', function(evt){
        console.log('change');

        var val = $slider.val();
        var offset = itemWidth * parseInt(val);

        $container.css('left', -offset);
    });
}

var tabs = function (element, targets) {
    var $tabs = $(element).find('li');
    var $targets = $(targets);
    var $slider = $('.slider input[type="range"]');

    $tabs.each(function(k, el) {
        var $el = $(el);
        var $link = $el.find('a');
        var $target = $($link.data('target'));

        $link.on('click', function(evt) {
            evt.preventDefault();
            evt.stopPropagation();

            $tabs.removeClass('active');
            $targets.removeClass('active');
            $target.addClass('active');
            $el.addClass('active');

            $slider.off('input.slider');


            setSliderValues($('.slider input[type="range"]'), $target.find('.item'));
            setSlider($('.slider input[type="range"]'), $target);            
        });
    });
}

var setArrows = function(arrows, slider, tabs) {
    var step = 4;

    var $left = $(arrows[0]);
    var $right = $(arrows[1]);
    var $slider = $(slider);
    var $tabs = $(tabs);
    var min = 0;

    if (parseInt($slider.val()) === 0) {
        $left.addClass('disabled');
    }

    $tabs.find('a').on('click', function(evt){
        $left.addClass('disabled');  
    });

    $left.on('click', function(evt){
        evt.preventDefault();
        evt.stopPropagation();

        var val = parseInt($slider.val());
        
        $right.removeClass('disabled');

        if (val - step <= min) {
            $slider.val(min).change();
            $left.addClass('disabled');
        } else {
            $slider.val(val - step).change();
            $left.removeClass('disabled');
        }
    });

    $right.on('click', function(evt){
        evt.preventDefault();
        evt.stopPropagation();

        var max = parseInt($slider.attr('max'));
        var val = parseInt($slider.val());
        
        $left.removeClass('disabled');

        if (val + step >= max) {
            $slider.val(max).change();
            $right.addClass('disabled');
        } else {
            $slider.val(val + step).change();
            $right.removeClass('disabled');
        }
    });
}

var moreLinks = function() {
    $('.see-all').on('click', function(evt){
        var $this = $(this);

        if ($this.hasClass('see-all-desktop')) {
            $('[data-target="#list-desktop"]').click();
        } else if ($this.hasClass('see-all-mobile')) {
            $('[data-target="#list-mobile"]').click();
        } else if ($this.hasClass('see-all-business')) {
            $('[data-target="#list-business"]').click();
        }
    });
}

$(document).ready(function(){
    setSliderValues($('.slider input[type="range"]'), $('#list-desktop .item'));
    setSlider($('.slider input[type="range"]'), $('#list-desktop'));
    tabs($('.tabs'), $('.awards-list'));
    setArrows([$('.slider-nav-left'), $('.slider-nav-right')], $('.slider input[type="range"]'), $('.tabs').find('li'));
    moreLinks();

    $('input[type="range"]').rangeslider();
});